import { XHRBackend } from '@angular/http';
import { AngularReduxRequestOptions } from '../_common/angular-redux-request-options';
import { HttpRequestService } from '../_common/http-request.service';
import { LoaderService } from '../_common/loader/loader.service';
import { Router, RouterModule } from '@angular/router';
import { AlertsService } from 'angular-alert-module';

function httpServiceFactory(backend: XHRBackend, options: AngularReduxRequestOptions, loaderService: LoaderService, router: Router, alerts: AlertsService) {
    return new HttpRequestService(backend, options, loaderService, router, alerts);
}
export { httpServiceFactory };


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_factories/http-service-factory.ts